import { teacherServiceURL } from '../endpoint';

export function startQuizUrl() {
  const url = new URL(teacherServiceURL);
  url.pathname += 'activity/quiz';
  return url;
}
